// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"e5a9fb8a","239":"5baef066","344":"312304f8","351":"1a565fe2","455":"e16aa38c","625":"3fee0206","701":"9a6029c0","766":"2b0afa6c","813":"f819aa06","977":"d9f3b7a0"}[chunkId] + ".chunk.js";
};